import { Injectable } from '@angular/core';
import { LendingTypes } from '../constants';
import { LendingType } from '../models';

const mockLendingType = {
  id: 1,
  name: 'Residential',
  code: LendingTypes.Residential,
  logoUrl: '',
  sortOrder: 1,
} as LendingType;

@Injectable()
export class MockLendingTypeService {
  lendingType: LendingType = mockLendingType;
  lendingTypes: LendingType[] = [mockLendingType];
}
